// extracted by mini-css-extract-plugin
export default {"statusNotification":"_1fElD___UploadStatus-module__statusNotification","error":"_2iKDD___UploadStatus-module__error"};